module.exports = __webpack_public_path__ + "ffb670fd5d8a8db3942056188aa4b819.svg";